export default __webpack_public_path__ + "static/media/silence.092417a0.svg";